var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0H0V0.75V18.75V19.5H0.75H20.75H21.5V18.75V0.75V0H20.75H0.75ZM1.5 18V1.5H20V18H1.5ZM5.49837 6.01902L4.91632 5.54604L3.97035 6.71015L4.55241 7.18313L10.3166 11.8671L10.7895 12.2514L11.2625 11.8671L17.0267 7.18313L17.6087 6.71015L16.6628 5.54604L16.0807 6.01902L10.7895 10.3186L5.49837 6.01902Z",
    fill: "#26CD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a9fe4590dff2d013826dac3b1b128018.svg";
export { ForwardRef as ReactComponent };